// IMAGES
export { default as logo }  from './images/wayride.png';
export { default as ride1 }  from './images/ride_1.jpg';
export { default as drivers }  from './images/drivers.png';
export { default as people }  from './images/people.png';
export { default as cash }  from './images/cash.png';
export { default as ride2 } from './images/ride_2.jpg';
export { default as send } from './images/send.png';
export { default as bell } from './bell.json';
export { default as lottieSupport } from './support.json';
export { default as map } from './images/map.svg';
export { default as journey1 } from './images/journey1.png';
export { default as journey2 } from './images/journey2.png';
export { default as avatar1 } from './images/avatar1.jpg';
export { default as avatar2 } from './images/avatar2.jpg';
export { default as avatar3 } from './images/avatar3.jpg';
export { default as loadingSVG } from './images/loading.svg';

//RINGTONES
export { default as notificationTone } from './ringtons/tone1.mp3' 